module.exports = __webpack_public_path__ + "static/media/youtubeIcon.900e3b1c.svg";